import httpClient from '@/api/http-client';

const endpoint = 'api/settings-driving-permit';

const settingsDrivingPermitService = {
  create: (drivingPermit) => httpClient.post(endpoint, drivingPermit),
};

export default settingsDrivingPermitService;
